import { pipelineStages } from "../../data/leadPipeline";
import useLeadPipeline from "../../hooks/useLeadPipeline";
import LeadPipelineLane from "./LeadPipelineLane";

export default function LeadPipeline({ leads, onRefresh }) {
  const { error, savedLeadId, savingLeadId, updateStatus } = useLeadPipeline(onRefresh);

  return (
    <section className="admin-section lead-pipeline" data-testid="admin-lead-pipeline">
      <div className="lead-pipeline-heading">
        <div>
          <span className="eyebrow">Relationship progression</span>
          <h2>LEAD PIPELINE</h2>
        </div>
        <span className="lead-pipeline-total" data-testid="lead-pipeline-total">
          {leads.length} total
        </span>
      </div>
      {error && <p className="form-error" data-testid="lead-pipeline-error">{error}</p>}
      {!leads.length && (
        <div className="empty-state" data-testid="lead-pipeline-empty-state">
          No leads are available in the pipeline yet.
        </div>
      )}
      {!!leads.length && (
        <div className="lead-pipeline-grid" data-testid="lead-pipeline-grid">
          {pipelineStages.map((stage) => (
            <LeadPipelineLane
              key={stage.value}
              leads={leads.filter((lead) => (lead.status || "new") === stage.value)}
              onStatusChange={updateStatus}
              savedLeadId={savedLeadId}
              savingLeadId={savingLeadId}
              stage={stage}
            />
          ))}
        </div>
      )}
    </section>
  );
}